module.exports = __webpack_public_path__ + "img/proj1-dscrank.7eff228d.png";